import styles from "./IframeTemplate.module.scss";
import { ReactNode } from "react";
import { useRouteMainFocus } from "../utils/useRouteMainFocus.ts";
import useAccessiblePageTitle from "../../../common/page-title/useAccessiblePageTitle.tsx";
import BaseHeader from "../../../common/header/BaseHeader.tsx";

export default function IframeTemplate({
  children,
  title,
}: {
  children: ReactNode;
  title: string;
}) {
  const accessiblePageTitle = useAccessiblePageTitle(title);
  useRouteMainFocus();

  return (
    <main aria-label={accessiblePageTitle} className={styles.main}>
      <BaseHeader />
      <div className={styles.iframeContainer}>{children}</div>
    </main>
  );
}
